import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import type { ServiceVendorId, EmployeeId } from '@/services/api/petseo.client.wrapper';
import type { CreateExternalReservationRequest } from '@/services/api/petseo.client.wrapper';
import { TOAST_MESSAGES, getApiErrorMessage, invalidateReservationViews, toast } from '@petseo/shared';

export const useCreateExternalReservation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      serviceVendorId,
      serviceVendorEmployeeId,
      data,
    }: {
      serviceVendorId: ServiceVendorId;
      serviceVendorEmployeeId: EmployeeId;
      data: CreateExternalReservationRequest;
    }) => {
      const response = await serviceVendorsClient.postExternalReservationEndpoint(data, serviceVendorId, serviceVendorEmployeeId);
      return response.data;
    },
    onSuccess: () => {
      invalidateReservationViews(queryClient);
      toast.success(TOAST_MESSAGES.EXTERNAL_RESERVATION_CREATED);
    },
    onError: (error) => toast.error(getApiErrorMessage(error, TOAST_MESSAGES.EXTERNAL_RESERVATION_CREATE_ERROR)),
  });
};
